import type { StatItem } from "../Types/StatItemType";
import { formatStatValue } from "../Helpers/formatStatValue";

/**
 * Renders a stat value as an anchor. Used wherever a StatItem carries an
 * `href` — the value itself becomes the link rather than gaining a separate
 * button, so the stat stays a single glanceable unit.
 */
export function StatValueLink_({ item }: { item: StatItem }) {
  return (
    <a
      href={item.href}
      className="underline-offset-2 hover:underline"
      {...(item.hrefExternal
        ? { target: "_blank", rel: "noopener noreferrer" }
        : {})}
    >
      {formatStatValue(item)}
    </a>
  );
}
